import React, { useState, useEffect } from 'react';
import { useTheme } from '../../context/ThemeContext';
import './welcome.css';

const PersonalizedWelcome = () => {
    const { theme } = useTheme();
    const [isVisible, setIsVisible] = useState(false);
    const [welcomeData, setWelcomeData] = useState({
        greeting: '',
        message: '',
        icon: '👋'
    });

    useEffect(() => {
        const hasSeenWelcome = sessionStorage.getItem('welcome_shown');
        
        if (!hasSeenWelcome) {
            // Get personalized greeting based on time of day
            const hour = new Date().getHours();
            let greeting = 'Hello';
            let message = 'Welcome to my portfolio!';
            let icon = '👋';

            if (hour >= 5 && hour < 12) {
                greeting = 'Good Morning';
                message = 'Start your day by exploring my projects!';
                icon = '🌅';
            } else if (hour >= 12 && hour < 17) {
                greeting = 'Good Afternoon';
                message = 'Thanks for stopping by!';
                icon = '☀️';
            } else if (hour >= 17 && hour < 22) {
                greeting = 'Good Evening';
                message = 'Discover what I\'ve been building!';
                icon = '🌆';
            } else {
                greeting = 'Hello Night Owl';
                message = 'Burning the midnight oil? Let\'s explore!';
                icon = '🌙';
            }

            // Check if returning visitor
            const visitCount = parseInt(localStorage.getItem('visit_count') || '0') + 1;
            localStorage.setItem('visit_count', visitCount.toString());

            if (visitCount > 1) {
                greeting = 'Welcome Back';
                message = `Great to see you again! This is visit #${visitCount}`;
                icon = '🎉';
            }

            setWelcomeData({ greeting, message, icon });
            
            // Show welcome banner after a short delay
            setTimeout(() => {
                setIsVisible(true);
            }, 500);

            // Auto-hide after 8 seconds
            setTimeout(() => {
                handleClose();
            }, 8000);

            sessionStorage.setItem('welcome_shown', 'true');
        }
    }, []);

    const handleClose = () => {
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div className={`welcome-banner ${theme === 'dark' ? 'dark' : 'light'} ${isVisible ? 'visible' : ''}`}>
            <div className="welcome-content">
                <div className="welcome-icon">{welcomeData.icon}</div>
                <div className="welcome-text">
                    <h2 className="welcome-greeting">{welcomeData.greeting}!</h2>
                    <p className="welcome-message">{welcomeData.message}</p>
                </div>
                <button 
                    onClick={handleClose}
                    className="welcome-close"
                    aria-label="Close welcome banner"
                >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                </button>
            </div>
            <div className="welcome-progress"></div>
        </div>
    );
};

export default PersonalizedWelcome;
